import { Account } from '../graphql/generated/graphql';
import { IAccount } from '@medely/types';

type AccountWithPushTokens = (Account | IAccount) & {
  account_push_registration_tokens?: string[];
};

export const hasPushTokens = (account?: AccountWithPushTokens | null): boolean => {
  if (!account) {
    return false;
  }

  return Boolean(
    account.account_push_registration_tokens && account.account_push_registration_tokens.length > 0,
  );
};

export const getPushTokensCount = (account?: AccountWithPushTokens | null): number => {
  if (!account) {
    return 0;
  }

  return account.account_push_registration_tokens?.length || 0;
};
